<!--  -->
<template>
  <div class="dsawr">
    <div>
      <div class="search_list">
        <div class="accopunr_list">
          <div>账号类型：</div>
          <el-radio-group v-model="pageIfon.inherit_type" @change="djawe">
            <el-radio :label="1">被继承</el-radio>
            <el-radio :label="2">正常</el-radio>
          </el-radio-group>
        </div>
        <div class="accopunr_list">
          <div>筛选时间：</div>
          <el-select v-model="pageIfon.filter" placeholder="请选择筛选时间" @change="djawe">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="accopunr_list">
          <div>组内/组外：</div>
          <el-select v-model="pageIfon.onlyMe" placeholder="请选择组内/组外" @change="djawe">
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>

      </div>

    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      max-height="500"
    >
      <el-table-column
        prop="user_id"
        label="用户ID"
        width="300"
        align="center"
      />
      <el-table-column
        prop="name"
        label="员工名称"
        width="300"
        align="center"
      />
      <el-table-column
        prop="extend_user_name"
        label="继承者"
        align="center"
        width="300"
      />
      <el-table-column
        prop="expire_time_text"
        label="过期时间"
        align="center"
      >
        <template slot-scope="scope">
          <div :class="{'activer':scope.row.been_expire === true,'activerno':scope.row.been_expire === false}">{{ scope.row.expire_time_text }}</div>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { accountAccessexpireAccount } from '@/api/bserw.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        page_size: 10,
        inherit_type: 1,
        filter: 1,
        onlyMe: 2
      },
      options: [{
        value: 1,
        label: '三天后过期'
      }, {
        value: 2,
        label: '七天后过期'
      }, {
        value: 3,
        label: '过期7天内'
      }, {
        value: 4,
        label: '已过期'
      }],
      loading: false,
      accountarr: [{
        value: 1,
        label: '查看组内'
      }, {
        value: 2,
        label: '查看组外'
      }]
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.exchangedata()
    },
    async exchangedata() {
      this.loading = true
      const data = await accountAccessexpireAccount(this.pageIfon)
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.exchangedata()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.exchangedata()
    },
    djawe() {
      this.exchangedata()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dsawr{
  padding: 20px;
}
.accopunr_list{
  display:flex;
  align-items: center;
  margin-bottom:10px
}
.activer{
  color: red;
}
.activerno{
  color: #67C23A;
}
</style>
